module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "ui center aligned header"
  }, [_vm._v("\n    Sale summary\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui bottom aligned very relaxed center aligned stackable equal width grid container"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    staticClass: "ui fluid image",
    attrs: {
      "src": require("../assets/info/iuor.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('p', [_vm._v("Intended use of revenue")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    staticClass: "ui fluid image",
    attrs: {
      "src": require("../assets/info/allocation.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('p', [_vm._v("Token distribution")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('code', [_vm._v("\n        1 ether = 100 ANT\n        "), _c('small', [_vm._v("first 2 weeks")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('code', [_vm._v("\n        1 ether = 66 ANT\n        "), _c('small', [_vm._v("last 2 weeks")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('code', [_vm._v("\n        Hidden cap\n        "), _c('small', [_vm._v("Will be revealed during the sale or prior to being reached")])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('p', [_vm._v("Token price and duration")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fc9ad0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SaleSummary.vue
// module id = 511
// module chunks = 1